const getIsItemEnabled = (index, currentVehicle, dealerCode) => {
    const { modelKey, modelYear, trimKey, transmissionKey, exteriorColorKey, interiorColorKey } = currentVehicle;
    const isModelSelected = !!(modelKey && modelYear);
    const isCurrentVehicleValid = !!(isModelSelected &&
        trimKey &&
        transmissionKey &&
        exteriorColorKey &&
        interiorColorKey);
    // ['Choose Model']
    if (index === 0)
        return true;
    // ['Pick Dealer']
    if (index === 1)
        return isModelSelected;
    // ['Availability']
    if (index === 2)
        return isModelSelected && !!dealerCode;
    // ['Vehicle Details']
    if (index === 3)
        return isCurrentVehicleValid && !!dealerCode;
    return false;
};
export default getIsItemEnabled;
